import CommonModal from "../../../../Component/Ui-Kits/Modal/Common/CommonModal";
import { H3 } from "../../../../AbstractElements";
import { Button } from "reactstrap";

export interface MobileOnlyModalProps {
  isOpen: boolean;
  handleOnClick: () => void;
}

const MobileOnlyModal = ({ isOpen, handleOnClick }: MobileOnlyModalProps) => {
  return (
    <CommonModal
      modalBodyClassName="p-4"
      centered
      isOpen={isOpen}
      showFooter={false}
    >
      <div className="d-flex flex-wrap justify-content-center">
        <H3 className="text-center">
          This page can only be accessed on mobile devices.
        </H3>
        <div className="mt-3">
          <Button className="m-auto" color="primary" onClick={handleOnClick}>
            Go To Dashboard
          </Button>
        </div>
      </div>
    </CommonModal>
  );
};

export default MobileOnlyModal;
